import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { useDemo } from "@/context/DemoContext";

export function CTA() {
  const { launchDemo } = useDemo();
  return (
    <section
      className="relative mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40"
      data-testid="cta-section"
    >
      <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.02] px-8 py-20 text-center sm:px-16">
        <div
          className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-20 blur-[120px]"
          style={{ background: "var(--accent)" }}
        />
        <div className="absolute inset-0 grid-lines opacity-40" />
        <div className="relative">
          <Reveal>
            <h2 className="font-display mx-auto max-w-3xl text-4xl font-light tracking-tight text-white sm:text-6xl">
              Experience Our Flagship Platform.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-body mx-auto mt-6 max-w-xl text-lg text-white/55">
              Explore Crash Ready through our interactive demonstration.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <motion.button
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.98 }}
              onClick={launchDemo}
              data-testid="cta-launch-demo-btn"
              className="group mt-10 inline-flex items-center gap-3 rounded-full px-8 py-4 text-lg font-medium text-white"
              style={{
                background: "var(--accent)",
                boxShadow: "0 0 40px var(--accent-glow)",
              }}
            >
              Launch Crash Ready Demo
              <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
            </motion.button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
